import card1_info from '../../images/card/card1_info.svg'
import card1_search from '../../images/card/card1_search.svg'
import card2 from '../../images/card/card2_chat.svg'
import card3_chat_total from '../../images/card/card3_chat_all.svg'
import card3_chat_team from '../../images/card/card3_chat_team.svg'
import card3_chat_doc from '../../images/card/card3_chat_doc.svg'

const data = [
  {
    img: [card1_info, card1_search],
    title: ['업무 커뮤니케이션도 ', '벽난로 앞 토크처럼', '편안하고 쉽게'],
    sub: ['각종 사내 시스템에서 채팅으로 바로 연결', '메신저 내에서 손쉽게 문서 탐색']
  },
  {
    img: [card2],
    title: ['사내 ', '중요 파일', '이 ', '쌓이는 만큼 ', '안전하게'],
    sub: ['오직 파일 보유자에 한해서만 채팅 생성 및 접근 가능']
  },
  {
    img: [card3_chat_total, card3_chat_team, card3_chat_doc],
    title: ['협업의 목표는 결국, ', '협업 콘텐츠의 완성!', '콘텐츠 기반 채팅이 필요한 이유'],
    sub: [
      '전체/문서/사용자 채팅으로 나뉘어 편의에 따라 채팅 확인',
      '조직도 기반 채팅을 생성해 편리한 업무 커뮤니케이션',
      '협업 콘텐츠 중심으로 자동으로 채팅방이 생성돼', 
      '빠르고 효율적인 협업 환경 구성'
    ]
}]

export default data;